import React from 'react'
import { ReactComponent as MenuSVG } from 'lib/assets/menu.svg'
import { ReactComponent as FoldSVG } from 'lib/assets/fold.svg'
import { ReactComponent as Raise } from 'lib/assets/raise.svg'
import { colors } from 'lib/colors'

export const GAME_DESCRIPTION = {
  title: 'Casino Hold’em',
  description: [
    `Casino Hold’em is Orbital’s one of the easiest games, designed with Provably Fair technology that makes the game outcomes totally random.`,
    `A 52-card deck is used to play the game. The player places an Ante or blind bet, as well as an optional bonus bet.`,
    `The main principle of the game is to have a total combination of cards that will beat the dealer’s card.`,
    `The dealer must have a pair of 4s or better to qualify.`,
    `If the dealer does not qualify, the Ante bet pays according to the Ante Win paytable and the Raise bet is a push.`,
    `If the dealer qualifies and the dealer's hand is the same as the player's, all bets are push`,
    `AA Bonus bet is based on the poker value of the player’s two cards and the first three flop cards`,
  ],
}
export const settings = [
  {
    icon: <MenuSVG className='menu' />,
    title: 'Settings Button',
    description: 'Press the button to access Settings',
    background: colors.secondary,
    color: colors.tertiaryDark,
  },
  {
    title: 'Provably Fair',
    description:
      'This section grants you the possibility of checking the fairness of the game for yourself',
  },
  {
    title: 'Game Rules',
    description: 'Short Description of the Game',
  },
  {
    title: 'History',
    description:
      'Shows your previous plays and allows you to devise new tactics for your next shuffle',
  },
  {
    title: 'Bet Reply',
    description: 'Click on any bet in history page to see your bet reply',
  },
  {
    title: 'Music',
    description: 'Turn on the unique audio overlay of the game',
  },
  {
    title: 'Sound',
    description: 'Enable unique action sounds of the game',
  },
  {
    title: 'Volume Bar',
    description: 'Set the volume',
  },
]

export const GameplayCustomization = [
  {
    title: 'Undo Button',
    description: 'Clears last bet',
    icon: 'UNDO',
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: '12px',
    width: '105px',
    height: '36px',
  },
  {
    title: 'Deal Button',
    description: 'Start the game',
    icon: 'DEAL',
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: '12px',
    width: '105px',
    height: '36px',
  },
  {
    title: 'AA Bet',
    description: 'Place a bet on the given position (voluntary bet)',
    icon: 'AA',
    background: colors.primaryLight,
    textColor: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'Ante Bet',
    description:
      'Place a bet on the given position for playing (mandatory bet)',
    icon: '0',
    background: colors.primaryLight,
    textColor: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'Raise Position',
    description: 'Raise amount will be displayed here',
    icon: <Raise />,
    background: colors.primaryLight,
    color: colors.tertiary,
    size: '16px',
    width: '56px',
    height: '56px',
  },
  {
    title: 'Click on bet amount',
    description: 'Betting Options:',
    background: colors.secondary,
    color: colors.tertiaryDark,
    size: '12px',
  },
  {
    title: 'Re-bet Button',
    description: 'Play next round with same bets',
    icon: 'REBET',
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: '12px',
    width: '105px',
    height: '36px',
  },
  {
    title: 'New Bets Button',
    description: 'Make a new bets for next round',
    icon: 'NEW BETS',
    background: colors.secondary,
    textColor: colors.primaryDark,
    size: '12px',
    width: '105px',
    height: '36px',
  },
]

export const RaiseContent = [
  {
    title: 'Raise Button',
    description:
      'In case of a good card combination, press the Raise button and automatically place a double bet of the ante. The 4th and 5th cards are opened, and the winner is revealed.',
    background: colors.secondary,
    color: colors.tertiaryDark,
    size: '12px',
  },
]

export const FoldContent = [
  {
    title: 'Fold Button',
    description:
      'In case of a not-so-good card combination, press the Fold button to stop the game and then start playing a new round.',
    background: colors.secondary,
    color: colors.tertiaryDark,
    size: '12px',
  },
]
